import { useEffect, useState } from "react";
import { getBadges } from "../lib/providers";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function Logo({ b, textOnly }) {
  const [broken, setBroken] = useState(false);
  if (b.logo && !broken && !textOnly) {
    return (
      <span className="flex h-6 w-6 items-center justify-center overflow-hidden rounded bg-white" title={b.name}>
        <img src={`${BACKEND}${b.logo}`} alt={b.name} loading="lazy" onError={() => setBroken(true)} className="h-full w-full object-contain" />
      </span>
    );
  }
  // fallback: short text label, never recolored logo
  return (
    <span className="flex h-6 items-center rounded bg-white px-1 text-[8px] font-bold uppercase leading-none text-black" title={b.name}>
      {b.name}
    </span>
  );
}

// Informational service badges. Renders identically in all skins.
export default function ServiceBadges({ id, className = "" }) {
  const { user } = useAuth();
  const { skin } = useTheme();
  const servicesKey = (user?.services || []).join(",");
  const [badges, setBadges] = useState([]);

  useEffect(() => {
    let alive = true;
    setBadges([]);
    getBadges(id, servicesKey).then((b) => { if (alive) setBadges(b); });
    return () => { alive = false; };
  }, [id, servicesKey]);

  if (!badges.length) return null;
  const shown = badges.slice(0, 3);
  const extra = badges.length - shown.length;

  return (
    <div className={`z-30 flex items-center gap-1 rounded-md bg-black/70 p-1 backdrop-blur-sm ${className}`} data-testid={`service-badges-${id}`}>
      {shown.map((b) => <Logo key={b.service_id} b={b} textOnly={skin === "clickwheel"} />)}
      {extra > 0 && (
        <span className="flex h-6 min-w-6 items-center justify-center rounded bg-white/20 px-1 text-[10px] font-bold text-white" data-testid={`service-badges-more-${id}`}>+{extra}</span>
      )}
    </div>
  );
}
